export default __webpack_public_path__ + "static/media/gtranslate-screenshot-05.fea422ac.png";